import { RequestStatus, isStatusHiddenFromLogist, type RequestKind } from '@magimp/shared';

// WHY: must equal `RequestListQuerySchema.q.max` in
//   `packages/shared/src/schemas/requests.ts`. Sending a longer value
//   would 400 the list request, which `RequestsListPage` would render
//   as an empty table because there's no per-error branch.
export const SEARCH_MAX_CHARS = 200;

export const STATUS_FILTER_IDS_FULL: readonly ('all' | RequestStatus)[] = [
  'all',
  RequestStatus.DRAFT,
  RequestStatus.READY_FOR_WORK,
  RequestStatus.IN_WORK,
  RequestStatus.RETURN,
  RequestStatus.PROCESSED,
  RequestStatus.POSTPONED,
  RequestStatus.SUCCESS,
  RequestStatus.REFUSED,
  RequestStatus.CANNOT_TRANSPORT,
  RequestStatus.CLOSED,
  RequestStatus.ARCHIVE,
];
// INVARIANT (#1159 PR5): hidden statuses are removed from the chip set
//   for logist actors so the page never renders a DRAFT or RETURN chip
//   whose count would be a misleading zero.
export const STATUS_FILTER_IDS_LOGIST: readonly ('all' | RequestStatus)[] =
  STATUS_FILTER_IDS_FULL.filter((id) => id === 'all' || !isStatusHiddenFromLogist(id));
export const SLA_FILTER_IDS: readonly ('hot' | 'overdue')[] = ['hot', 'overdue'];
export const KIND_FILTER_IDS: readonly RequestKind[] = ['STANDARD', 'CONTAINER', 'SIMPLE'];
